import { createActionGroup, props } from '@ngrx/store';

export const TourManagerActions = createActionGroup({
  source: 'Tour Manager',
  events: {
    'Set Tour Start': props<{ tourStart: boolean }>(),
  },
});